"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _themeGet = require("@styled-system/theme-get");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-empty-function,no-confusing-arrow */
var StyledTabHeader = (0, _styledComponents["default"])(_pclnDesignSystem.Button).withConfig({
  componentId: "zqx06t-0"
})(["display:flex;background-color:", ";color:", ";font-size:", "px;padding:", "px;border:1px solid ", ";box-shadow:0 2px 0 0 ", ";border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom:none;border-top:", ";outline:none;:hover{background-color:", ";}"], function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.backgroundColor)(props);
}, function (props) {
  return props.isActive ? (0, _pclnDesignSystem.getPaletteColor)(props.activeColor)(props) : (0, _pclnDesignSystem.getTextColorOn)(props.backgroundColor)(props);
}, (0, _themeGet.themeGet)('fontSizes.3'), (0, _themeGet.themeGet)('space.3'), function (props) {
  return props.isActive ? (0, _pclnDesignSystem.getPaletteColor)('border.base')(props) : 'transparent';
}, function (props) {
  return props.isActive ? (0, _pclnDesignSystem.getPaletteColor)(props.boxShadowColor)(props) : 'transparent';
}, function (props) {
  return props.isActive ? "3px solid ".concat((0, _pclnDesignSystem.getPaletteColor)(props.activeColor)(props)) : 'inherit';
}, (0, _pclnDesignSystem.getPaletteColor)('background.lightest'));
var TabHeader = (0, _react.memo)(function (_ref) {
  var index = _ref.index,
      title = _ref.title,
      isActive = _ref.isActive,
      activeColor = _ref.activeColor,
      _onClick = _ref.onClick,
      backgroundColor = _ref.backgroundColor,
      boxShadowColor = _ref.boxShadowColor;
  return _react["default"].createElement(StyledTabHeader, {
    isActive: isActive,
    activeColor: activeColor,
    onClick: function onClick() {
      return _onClick(index);
    },
    backgroundColor: backgroundColor,
    boxShadowColor: boxShadowColor
  }, title);
});
TabHeader.displayName = 'TabHeader';
TabHeader.propTypes = {
  index: _propTypes["default"].number.isRequired,
  title: _propTypes["default"].node.isRequired,
  isActive: _propTypes["default"].bool,
  activeColor: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  backgroundColor: _propTypes["default"].string,
  boxShadowColor: _propTypes["default"].string
};
TabHeader.defaultProps = {
  onClick: function onClick() {},
  activeColor: 'primary.base',
  backgroundColor: 'background.lightest',
  boxShadowColor: 'background.lightest'
};
/** @component */

var _default = (0, _styledComponents.withTheme)(TabHeader);

exports["default"] = _default;